import React, { useEffect, useState } from 'react';
import { Button, Chip, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { PageLayout, PageHeader, SectionCard, EmptyState, LoadingState } from '../../components/ui';
import { fetchMySurveys } from '../../services/surveysApi';

const STATUS_LABEL = { not_started: 'Not started', in_progress: 'In progress', submitted: 'Completed' };
const STATUS_COLOR = { not_started: 'default', in_progress: 'warning', submitted: 'success' };

export default function MySurveysPage() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    fetchMySurveys()
      .then((data) => { if (active) setItems(Array.isArray(data) ? data : []); })
      .catch(() => toast.error('Failed to load your surveys.'))
      .finally(() => { if (active) setLoading(false); });
    return () => { active = false; };
  }, []);

  if (loading) return <LoadingState />;

  return (
    <PageLayout>
      <PageHeader title="My Surveys" subtitle="Surveys assigned to you" />
      {items.length === 0 ? (
        <EmptyState title="No surveys assigned" description="You have no surveys to complete right now." />
      ) : (
        <Stack spacing={2}>
          {items.map((s) => (
            <SectionCard
              key={s.id}
              title={s.title}
              action={(
                <Button
                  variant="contained"
                  disabled={s.my_status === 'submitted' || !s.is_open}
                  onClick={() => navigate(`/my/surveys/${s.id}`)}
                >
                  {s.my_status === 'in_progress' ? 'Continue' : s.my_status === 'submitted' ? 'Completed' : 'Start'}
                </Button>
              )}
            >
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Chip
                  size="small"
                  label={STATUS_LABEL[s.my_status] || s.my_status}
                  color={STATUS_COLOR[s.my_status] || 'default'}
                />
                <Typography variant="body2" color="text.secondary">
                  {s.questions_count} question(s)
                </Typography>
                {s.end_date && (
                  <Typography variant="caption" color="text.secondary">
                    Closes {new Date(s.end_date).toLocaleDateString()}
                  </Typography>
                )}
              </Stack>
              {s.description && (
                <Typography variant="body2" sx={{ mt: 1 }}>{s.description}</Typography>
              )}
            </SectionCard>
          ))}
        </Stack>
      )}
    </PageLayout>
  );
}
